import store from "../Redux/Store";

export default function checkIfItemGstDetailsExists(itemData) {
  const isGSTEnabled = !!store.getState().gstBillingReducer.gstBilling?.gst_enabled;
  const hasGSTDetails = !!(itemData?.hsn && itemData?.gst_rate?.text);
  return isGSTEnabled || hasGSTDetails;
}
